import React, { memo } from 'react'

interface VideoIconProps {
  size?: number
  className?: string
}

const VideoIcon: React.FC<VideoIconProps> = memo(({ size = 32, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 33"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2 8.50078C19.2 7.65209 18.8629 6.83816 18.2627 6.23804C17.6626 5.63792 16.8487 5.30078 16 5.30078H3.2C2.35131 5.30078 1.53737 5.63792 0.937258 6.23804C0.337142 6.83816 0 7.65209 0 8.50078V24.5008C0 25.3495 0.337142 26.1634 0.937258 26.7635C1.53737 27.3636 2.35131 27.7008 3.2 27.7008H16C16.8487 27.7008 17.6626 27.3636 18.2627 26.7635C18.8629 26.1634 19.2 25.3495 19.2 24.5008V8.50078ZM22.4 23.52L29.8944 26.0192C30.1349 26.0993 30.3911 26.1211 30.6417 26.0828C30.8923 26.0445 31.1302 25.9472 31.3358 25.7989C31.5415 25.6506 31.7089 25.4556 31.8244 25.2299C31.9399 25.0042 32.0001 24.7543 32 24.5008V8.50078C32.0001 8.24726 31.9399 7.99735 31.8244 7.77165C31.7089 7.54595 31.5415 7.35092 31.3358 7.20263C31.1302 7.05435 30.8923 6.95705 30.6417 6.91875C30.3911 6.88046 30.1349 6.90227 29.8944 6.98238L22.4 9.48158V23.52Z"
      fill="currentColor"
    />
  </svg>
))

VideoIcon.displayName = 'VideoIcon'

export { VideoIcon }
